import { useEffect } from 'react';
import { baseUrl, getRequest } from '../utils/services';
import { useErrorStore } from '../stores/useErrorStore';
import { useQuickAnswersStore } from '../stores/useQuickAnswersStore';
import { useTicketStore } from '../stores/useTicketStore';

export function useChatBootstrap(user) {
  const internalChats = useTicketStore((state) => state.internalChats);
  const openTickets = useTicketStore((state) => state.openTickets);
  const userChatsQueue = useTicketStore((state) => state.userChatsQueue);
  const setUnreadInternalMessagesCount = useTicketStore(
    (state) => state.setUnreadInternalMessagesCount,
  );
  const setQuickAnswersData = useQuickAnswersStore((state) => state.setQuickAnswersData);
  const setErrorMessage = useErrorStore((state) => state.setErrorMessage);

  useEffect(() => {
    if (!user) {
      return;
    }

    useTicketStore.getState().getOpenTickets(user, setErrorMessage);
    useTicketStore.getState().getUserChatsQueue(user, setErrorMessage);
    useTicketStore.getState().getUserChats(user, 1);
    useTicketStore.getState().getInternalChats(user, setErrorMessage);
    useTicketStore.getState().getAllUsers(user, setErrorMessage);
    useTicketStore.getState().getDepartments(user, setErrorMessage);

    const getQuickAnswers = async () => {
      const response = await getRequest(`${baseUrl}/messages/quickAnswers/${user.id}`);

      if (response.error) {
        setErrorMessage(
          'Erro ao buscar mensagens rápidas do usuário. Entre em contato com o suporte',
        );
        return;
      }

      setQuickAnswersData(response);
    };

    getQuickAnswers();
  }, [setErrorMessage, setQuickAnswersData, user]);

  useEffect(() => {
    if (!user) {
      return undefined;
    }

    const interval = setInterval(() => {
      useTicketStore.getState().getOpenTickets(user, setErrorMessage);
    }, 600000);

    return () => clearInterval(interval);
  }, [setErrorMessage, user]);

  useEffect(() => {
    const unreadInternalMessages = internalChats.reduce(
      (accumulator, chat) => accumulator + (chat.unreadCount || 0),
      0,
    );

    setUnreadInternalMessagesCount(unreadInternalMessages);
  }, [internalChats, setUnreadInternalMessagesCount]);

  useEffect(() => {
    const unreadInOpenTickets = openTickets.reduce(
      (sum, ticket) => sum + (ticket.unreadCount || 0),
      0,
    );
    const unreadInUserChatsQueue = userChatsQueue.reduce(
      (sum, chat) => sum + (chat.unreadCount || 0),
      0,
    );
    const totalUnreadCount = unreadInOpenTickets + unreadInUserChatsQueue;

    document.title = totalUnreadCount > 0 ? `Chat Telein (${totalUnreadCount})` : 'Chat Telein';

    return () => {
      document.title = 'Chat Telein';
    };
  }, [openTickets, userChatsQueue]);
}
